/** Persist expanded native sheet height across steps and nested sheets in a flow. */
let preferExpanded = false;

const OPEN_NATIVE_SHEET_SELECTOR = [
  '[data-state="open"][role="dialog"].native-bottom-sheet',
  '[data-state="open"][role="dialog"].native-option-sheet',
  '[data-state="open"][role="dialog"].native-test-sheet',
  '[data-state="open"][role="dialog"].rounded-t-2xl',
].join(", ");

const EXPANDABLE_SHEET_SELECTOR = [
  '[data-state="open"].native-sheet-expandable',
  '[data-state="open"].native-nested-expandable-sheet',
  '[data-state="open"].native-user-details-sheet',
  '[data-state="open"].native-test-sheet.native-sheet-expandable',
].join(", ");

export function countOpenNativeSheets(): number {
  if (typeof document === "undefined") return 0;
  return document.querySelectorAll(OPEN_NATIVE_SHEET_SELECTOR).length;
}

/** Apply expanded/collapsed class to every open expandable sheet in the stack. */
export function syncNativeSheetExpandState(expanded: boolean): void {
  if (typeof document === "undefined") return;
  document.querySelectorAll(EXPANDABLE_SHEET_SELECTOR).forEach((el) => {
    if (expanded) el.classList.add("native-sheet-expanded");
    else el.classList.remove("native-sheet-expanded");
  });
}

export const nativeSheetExpandPreference = {
  get: () => preferExpanded,
  set: (value: boolean) => {
    preferExpanded = value;
    syncNativeSheetExpandState(value);
  },
  reset: () => {
    preferExpanded = false;
    syncNativeSheetExpandState(false);
  },
};
